import { IUpdateItemMedicaoUseCase } from "../../../presentation/useCases/update/update_item_medicao_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// UpdateItemMedicaoUseCase


export class UpdateItemMedicaoUseCase implements IUpdateItemMedicaoUseCase
 {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateItemMedicao(IdItemMedicaoTerceirizacao: number,
  IdMedicaoTerceirizacao: number | null, IdProdutoServico: number | null, IdSubconta: number | null, Detalhamento: string | null, Quantidade: number | null, ValorUnitario: number | null, ValorTotal: number | null
  ): Promise<void> {
    
    await this.repository.updateItemMedicao(
     IdItemMedicaoTerceirizacao, IdMedicaoTerceirizacao, IdProdutoServico, IdSubconta, Detalhamento, Quantidade, ValorUnitario, ValorTotal
    );
  }
}
